goog.module('yext.location.RichText');
goog.module.declareLegacyNamespace();

const yext = goog.require('yext');

/**
 * Custom Rich Text field
 *
 * @param {!jQuery} $ctx Parent element for the field
 * @constructor
 * @author Andrew Lauria (alauria@yext.com)
 */
const RichText = function($ctx) {
  this.$ctx = $ctx;
  this.$input = this.$ctx.find('.js-rich-text-edit-input');
  this.indeterminate = false;
  this.fieldName = this.$ctx.find('input[name="field"]').val();
  this.storeValue();
  this.bind();

  this.assetOrOriginal = true;
  this.originalValue = this.$input.val();
};

/**
 * Broadcast messages with the field as context
 */
RichText.prototype.message = function(message) {
  $(this).trigger(message);
};

/**
 * Reset the field to a stored state
 */
RichText.prototype.reset = function() {
  this.set({
    value: this.storedValue.value,
    indeterminate: this.storedValue.indeterminate,
  });
};

/**
 * Set the fields value
 *
 * @param {string} field Field data
 */
RichText.prototype.set = function(field) {
  this.$input.val(field.value).trigger('change');
  this.indeterminate = !!field.indeterminate;
};

/**
 * Store the state for use in reset
 */
RichText.prototype.storeValue = function($display) {
  this.storedValue = {
    value: this.$input.val(),
    indeterminate: this.indeterminate,
  };
  if ($display !== undefined) {
    $display.find('.js-rich-text-view').each((i, container) => {
      let input = $(container).find('.js-rich-text-display-input');
      $(input).val(this.storedValue.value).trigger('change');
    });
  }
};

/**
 * Bind the update events
 */
RichText.prototype.bind = function() {
  var self = this;

  this.$input.inputchange(function() {
    self.message('updated');
    $(self).trigger('update.struct');
    $(self).trigger('update.list');
    self.updateAssetOrOriginal(false);
  });
};

/**
 * Get timestamp
 *
 * @return {string} Timestamp for rich text field
 */
RichText.prototype.getTimestamp = function() {
  return this.$ctx.find('.js-field-timestamp').val();
};

/**
 * Package relevant field info to send to a parent struct.
 */
// todo fix here
RichText.prototype.getJSONData = function() {
  return {
    [this.fieldName + '.value']: this.$input.val(),
    [this.fieldName + '.timestamp']: this.getTimestamp(),
  };
};

/**
 * Apply values to this field from an asset. Also set the assetOrOriginal flag to true.
 */
RichText.prototype.applyAsset = function(fieldValues) {
  this.set(fieldValues);
  $(this).trigger('update.struct');
  this.updateAssetOrOriginal(true);
};

/**
 * Update the asset or original flag.
 */
RichText.prototype.updateAssetOrOriginal = function(fromAsset) {
  if (fromAsset || this.originalValue === this.$input.val()) {
    this.assetOrOriginal = true;
  } else {
    this.assetOrOriginal = false;
  }
};

/**
 * Type-ubiquitous function for checking assetOrOriginal flag.
 */
RichText.prototype.checkAssetOrOriginalFlag = function() {
  return this.assetOrOriginal;
};

/**
 * The after save function when this field is a child of a struct.
 */
RichText.prototype.setFromStruct = function(fieldValue, $display, $viewTemplate /* unused */, cannotEdit) {
  this.set(fieldValue);
  this.storeValue($display);

  // reset asset approvals values
  this.assetOrOriginal = true;
  this.originalValue = this.$input.val();
};

/**
 * clears field
 */
RichText.prototype.clear = function() {
  this.set({
    value: '',
    indeterminate: false,
  });
};

exports = RichText;
